import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TemplateContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minHeight: '100vh',
}));

export const TemplateBody = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
